import './index.scss';

import { Field } from 'vant';
import { DialogView } from '@hb/coffee';
import { Component, Vue } from 'vue-property-decorator';

interface Options {
  title?: string;
  text?: string;
}
@Component({ name: 'TextDialog' })
class TextDialog extends Vue {
  private show = false;

  private resolve: PromiseResolve<string> | undefined;

  private reject: PromiseReject | undefined;

  private text = '';

  private title = '';

  public async open(option?: Options): Promise<string> {
    this.show = true;
    this.text = (option && option.text) || '';
    this.title = (option && option.title) || '';

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private onConfirm() {
    if (this.resolve) {
      this.resolve(this.text);
    }

    this.close();
  }

  private close() {
    this.show = false;
  }

  private onCancel() {
    if (this.reject) {
      this.reject();
    }

    this.close();
  }

  private render() {
    return (
      <DialogView
        class="TextDialog"
        show={this.show}
        title={this.title}
        closeable={false}
        showCancelButton
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        zIndex={10001}
      >
        <Field v-model={this.text} type="textarea" border autosize />
      </DialogView>
    );
  }
}

let instance: TextDialog;

export const openTextDialog = (option?: Options): Promise<string> => {
  if (!instance) {
    instance = new TextDialog().$mount();
    document.body.appendChild(instance.$el);
  }

  return instance.open(option);
};
